import { NavMobile } from '../components/nav-mobile';
import { TheMarketFooter } from './footer';
import { TheMarketHeader } from './header';
import { ScrollTop } from '@/client/layouts/components/scroll-top';
import { PropsWithChildren } from 'react';

export type TheMarketLayoutProps = PropsWithChildren;

export const TheMarketLayout = ({ children }: TheMarketLayoutProps) => {
  return (
    <>
      <TheMarketHeader />
      <main className="w-full max-w-screen-3xl mx-auto">{children}</main>
      <NavMobile />
      <ScrollTop />
      <TheMarketFooter />
    </>
  );
};

export default TheMarketLayout;
